/* generated by pull.js */
const manifest = {
  "noTranslations": true,
  "name": "Custom default Brush, Eraser and Pen smoothing",
  "description": "Makes the default values for Brush, Eraser and Pen smoothing configurable.",
  "credits": [
    {
      "name": "JeremyGamer13"
    }
  ],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "settings": [
    {
      "name": "Brush Smoothing",
      "id": "brush",
      "type": "integer",
      "min": 0,
      "max": 1000,
      "default": 10
    },
    {
      "name": "Eraser Smoothing",
      "id": "eraser",
      "type": "integer",
      "min": 0,
      "max": 1000,
      "default": 10
    },
    {
      "name": "Pen Smoothing",
      "id": "pen",
      "type": "integer",
      "min": 0,
      "max": 1000,
      "default": 2
    },
  ],
  "dynamicEnable": true,
  "dynamicDisable": true,
  "enabledByDefault": false,
  "tags": []
};
export default manifest;